import { apiGet, apiPatch } from './client';
import type { Crcy, CrcyBatchRequest } from '../types/Crcy';

export function getCrcies(): Promise<Crcy[]> {
  return apiGet<Crcy[]>('/api/crcy');
}

export function saveCrciesBatch(
  added: Crcy[],
  modified: Crcy[],
  deletedIds: number[],
): Promise<Crcy[]> {
  return apiPatch<CrcyBatchRequest, Crcy[]>('/api/crcy/batch', {
    added,
    modified,
    deleted: deletedIds,
  });
}
